<template>
    <div class="box-container mt-2 mb-2 d-flex flex-column justify-top">
        <v-container class="pa-0">
            <v-row dense>

                <v-col cols="12" v-if="project && project.started_count>=0">
                    <stat-box-skinny-numerical :value="project.started_count"
                                               hint="Starts"
                                               secondary-color="#777777"
                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project && project.completed_count>=0">
                    <stat-box-skinny-numerical :value="calculatePercent(project.completed_count)"
                                               hint="Completed"
                                               secondary-color="#388E3C"
                                               postfix="%"
                                               :mouse-over-value="project.completed_count"
                                               mouse-over-hint="Count"
                                               mouse-over-secondary-color="#388E3C"
                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project">
                    <stat-box-skinny-numerical :value="calculatePercent(project.profile_count)"
                                               hint="Profile"
                                               secondary-color="#927300"
                                               postfix="%"
                                               :mouse-over-value="project.profile_count"
                                               mouse-over-hint="Count"
                                               mouse-over-secondary-color="#927300"
                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project">
                    <stat-box-skinny-numerical :value="calculatePercent(project.quota_count)"
                                               hint="Quota"
                                               secondary-color="#c48a14"
                                               postfix="%"
                                               :mouse-over-value="project.quota_count"
                                               mouse-over-hint="Count"
                                               mouse-over-secondary-color="#c48a14"

                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project && project.quality_count>0">
                    <stat-box-skinny-numerical :value="calculatePercent(project.quality_count)"
                                               :color="qualityColor"
                                               secondary-color="#bf680c"
                                               hint="Quality"
                                               postfix="%"
                                               :mouse-over-value="project.quality_count"
                                               mouse-over-hint="Count"
                                               mouse-over-secondary-color="#bf680c"
                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project && project.duplicate_count>0">
                    <stat-box-skinny-numerical :value="calculatePercent(project.duplicate_count)"
                                               :color="duplicateColor"
                                               hint="Duplicates"
                                               secondary-color="#e75930"
                                               mouse-over-hint="Count"
                                               :mouse-over-value="project.duplicate_count"
                                               mouse-over-secondary-color="#e75930"
                                               postfix="%"
                    ></stat-box-skinny-numerical>
                </v-col>

                <v-col cols="12" v-if="project && project.security_count>0">
                    <stat-box-skinny-numerical :value="calculatePercent(project.security_count)"
                                               :color="securityColor"
                                               hint="Security"
                                               secondary-color="#d20a0a"
                                               mouse-over-hint="Count"
                                               :mouse-over-value="project.security_count"
                                               mouse-over-secondary-color="#d20a0a"
                                               postfix="%"
                    ></stat-box-skinny-numerical>
                </v-col>

            </v-row>
        </v-container>
    </div>
</template>

<script>

import Json from 'vue-json-pretty';
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import StatBoxSkinnyNumerical from "../../../../components/UI/StatBoxSkinnyNumerical";

export default {

    components: {
        StatBoxSkinnyNumerical,
        Json,
        StatBoxNumerical
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },
    computed: {

        qualityColor() {
            if (this.project.quality_count === 0) return "grey darken-2";
            const overFivePercent = (this.project.quality_count / this.project.started_count * 100) > 5;
            return overFivePercent ? "red" : "orange darken-1";
        },

        duplicateColor() {
            if (this.project.duplicate_count === 0) return "grey darken-2";
            const overFivePercent = (this.project.duplicate_count / this.project.started_count * 100) > 5;
            return overFivePercent ? "red" : "orange darken-1";
        },

        securityColor() {
            if (this.project.security_count === 0) return "grey darken-2";
            const overFivePercent = (this.project.security_count / this.project.started_count * 100) > 5;
            return overFivePercent ? "red" : "orange darken-1";
        },
    },

    data() {
        return {}
    },

    methods: {

        calculatePercent(field) {
            if (field === 0 || this.project.started_count === 0) return 0;
            const percent = Math.round(field / this.project.started_count * 10000) / 100;
            if (percent > 3) return Math.round(percent);
            return percent;
        },
    }
}
</script>

<style scoped>

.box-container {
    height: 100%;
}

</style>